import React from 'react';
import ShareOutlinedIcon from '@mui/icons-material/ShareOutlined';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import classes from './shareButton.module.scss';
import { setNotification } from '../../../../actions/appNotifications';
import { appNotificationsTypes } from '../../../../utils/constants';

function ShareButton(props) {
  const { elemType = 'button', isLarge = false, title = '', text = '', url } = props;

  const dispatch = useDispatch();
  const { t } = useTranslation();

  const shareHandler = () => {
    if (navigator.share) {
      navigator.share({
        text,
        url,
        title
      });
    } else {
      dispatch(
        setNotification({
          type: appNotificationsTypes.SUCCESS,
          message: t('common.general.copied'),
          duration: 3000
        })
      );
      navigator.clipboard.writeText(url);
    }
  };

  return (
    <button
      className={`${elemType === 'button' ? classes.button : classes.textButton} ${isLarge ? classes.large : ''}`}
      onClick={shareHandler}
    >
      <ShareOutlinedIcon color="#0194d3" fontSize="15px" />
      <span>{t('common.general.share')}</span>
    </button>
  );
}

export default ShareButton;
